import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Divider, Row, Col } from "antd";
import  PropTypes from 'prop-types';
import moment from 'moment';
import {
    PageSectionHeading,
    SectionSubHeading,
    SectionSpacing
} from '../../../../../../CommonComponents/commonStyles';
import { getAccountData } from '../../../../../../utils/sessionUtil';
import { createNewSingleExchange, createNewRecurringExchange } from '../../../../../../services/apiServices';
import Context from '../../context';
import { FlexContainer, PageHeading, ButtonWrapper, AddTransaction, AddExchangeMessage, AddExchangeSection } from './styles';
import { NavigationBtnContainer, CustomSectionSpacing } from '../../styles';
import EditButton from '../editButton';
import FromTable from './FromTable';
import ToTable from './ToTable';
import ExchangeOptions from '../exchangeOptions';
import ExchangeSchedule from '../exchangeSchedule';
import {
    ScheduleType as ScheduleTypeConstants,
    ExchangeType as ExchangeTypeConstants,
    AllocationType as AllocationTypeConstants,
    DateFormat,
    Frequency as FrequencyConstants,
    ExchangesMaxLimit as ExchangesMaxLimitConstant
} from '../../constants';
import SpawnTable from './SpawnTable';
import { getInitialData } from '../../util';
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import { GeneralButton, CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';

export const ExchangeReview = (props) => {
    const { userId, history, handleExit, id, location, isNew, csrBusinessFunction } = props;
    const { exchangeContext, setExchangeContext } = React.useContext(Context);    
    const { from={}, to={} } = exchangeContext || {};
    const { partyId } = getAccountData();
    const [isSubmit, setIsSubmitted] =  useState(false)
    /** Only Mount and un-mount effect for scrolling don't add anything here */
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigateToConfirmation = (data, isSingle) => {
        const id = isSingle ? data.txnId : data.scheduleId;
        const tmp = getInitialData();
        // Only store confimation data in context for confirmation page
        tmp.confirmation = data;
        setExchangeContext(tmp);
        window.sessionStorage.removeItem('recommend-an-exchange');
        setIsSubmitted(false)
        history.push({
            pathname: `/investments/recommend-an-exchange/${id}/confirmation`,
            search: `type=${isSingle ? 'onetime' : 'recurring'}`
        })
    };

    const handleSubmit = () => {
        try {
            const data = {
                accountId: userId,
                partyId: partyId,
                startDate: from.scheduleType === ScheduleTypeConstants.onetime ? moment().format("MM/DD/YYYY") :
                    from.scheduleType === ScheduleTypeConstants.recurring ? moment(from.startDate).format("MM/DD/YYYY") : '',
                exchangeType: from.exchangeType === ExchangeTypeConstants.custom ? 'Custom Exchange' :
                    from.exchangeType === ExchangeTypeConstants.reallocation ? 'Reallocation Exchange' : '', //
                category: from.scheduleType === ScheduleTypeConstants.onetime ? 'Single Exchange' :
                    from.scheduleType === ScheduleTypeConstants.recurring ? 'Recurring Exchange' : '',
                unit: from.exchangeType === ExchangeTypeConstants.reallocation ? 
                    'DOLLAR'
                    : from.allocationType === AllocationTypeConstants.unit ? 'UNITS' :
                        from.allocationType === AllocationTypeConstants.dollar ? 'DOLLAR' :
                        from.allocationType === AllocationTypeConstants.percentage ? 'PERCENT' : '',
                exchangeFrom: from.pools.map((item) => {
                    return {
                        poolId: item.poolId,
                        pool: item.poolName,
                        value: from.exchangeType === ExchangeTypeConstants.reallocation ? 
                            `${item.dollar}`
                            : from.allocationType === AllocationTypeConstants.unit ? `${item.unit}` :
                                from.allocationType === AllocationTypeConstants.dollar ? `${item.dollar}` :
                                    from.allocationType === AllocationTypeConstants.percentage ? `${item.percentage}` : '',
                    };
                }),
                exchangeTo: to.pools.map((item) => {
                    return {
                        poolId: item.poolId,
                        pool: item.investmentOption,
                        percentage: item.percentage,
                    };
                })
            };
            
            if (from.scheduleType === ScheduleTypeConstants.recurring) {
                data.endDate = moment(from.endDate).format("MM/DD/YYYY");
                data.frequency = from.frequency === FrequencyConstants.weekly ? 'Weekly'
                    : from.frequency === FrequencyConstants.monthly ? 'Monthly'
                        : from.frequency === FrequencyConstants.quaterly ? 'Quarterly' : '';
                data.startDay = 'Monday'; //FIXME
                data.numberOfExchanges = from.numberOfExchanges.toString();
            }
    
            if (from.scheduleType === ScheduleTypeConstants.onetime) {
                setIsSubmitted(true);
                createNewSingleExchange({ accountId: userId, data }).then((res) => {
                    navigateToConfirmation(res.data, true);
                });
            } else if (from.scheduleType === ScheduleTypeConstants.recurring) {
                setIsSubmitted(true);
                createNewRecurringExchange({ accountId: userId, data }).then((res) => {
                    navigateToConfirmation(res.data, false);
                });
            }
        } catch (error) {
          recordError(error);
        }   
    }

    const handleBack = () => {
        try {
            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange'
            initiateTracking('back', 'Recommend An Exchange', 'Step 3 Review exchange and submit', `Back - ${scheduleTypeLabel}`);
            history.push({
                pathname: `/investments/recommend-an-exchange/${id}/to`,
                search: location.search.edit
            });
        } catch (error) {
          recordError(error);
        }
    }

    const addPayment = () => {
        try {
            const tmp = { ...exchangeContext };
            const numberOfExchanges = Number(from.numberOfExchanges) + 1;
            let end = from.startDate ? moment(from.startDate, DateFormat) : undefined;
            if (from.frequency === FrequencyConstants.quaterly) {
                end && end.add(from.numberOfExchanges ? Number(from.numberOfExchanges) : 1, 'Q')
            } else if (from.frequency === FrequencyConstants.monthly) {
                end && end.add(from.numberOfExchanges ? Number(from.numberOfExchanges) : 1, 'M')
            } else if (from.frequency === FrequencyConstants.weekly) {
                end && end.add(from.numberOfExchanges ? Number(from.numberOfExchanges) : 1, 'w')
            }
            tmp.from.numberOfExchanges = numberOfExchanges;
            tmp.from.endDate = end ? end.format(DateFormat) : ''
            setExchangeContext(tmp);
            initiateTracking('addPayment', 'Recommend An Exchange', 'Step 3 Review exchange and submit', 'Add Payment - Recurring Exchange');
        } catch (error) {
          recordError(error);
        }
    }

    // Check the feature is avalilable by the particular csr user
    const checkCsrBusiness = businessFunction => {
        return checkCSRBusinessFunction(BUSINESS_FUNCTION[businessFunction], csrBusinessFunction);
    }

    return (
        <div data-test="container">
            <PageSectionHeading>Review your exchange</PageSectionHeading>
            <SectionSubHeading className="mb-lg3 mb-sm4">
                Review and/or adjust your exchange recommendation below before submitting.
            </SectionSubHeading>
            <Divider className="m0" />
            <CustomSectionSpacing>
                <Row>
                    <ExchangeOptions
                        scheduleType={from?.scheduleType}
                        exchangeType={from?.exchangeType}
                        total={from?.total}
                        edit={true}
                        history={history}
                        id={id}
                        location={location}
                        isNew={isNew}
                    />
                    {from && from.scheduleType === ScheduleTypeConstants.recurring ?
                        <ExchangeSchedule
                            scheduleType={from?.scheduleType}
                            frequency={from?.frequency}
                            numberOfExchanges={from?.numberOfExchanges}
                            startDate={from?.startDate}
                            endDate={from?.endDate}
                            edit={true}
                            history={history}
                            id={id}
                            isViewEdit={false}
                        /> : ''
                    }
                </Row>
            </CustomSectionSpacing>
            <Divider className="m0" />
            {/** Do not show  Recommend Exchange From when exchange type is FromTIFF */}
            {!(from.exchangeType === ExchangeTypeConstants.fromTIFF) && <SectionSpacing>
                <FlexContainer>
                    <PageHeading>Recommend exchange from</PageHeading>
                    <CapsuleButton iconType="edit" text="Edit" id="btnEditExchangeFrom" onClick={(e) => {
                        try {
                            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                            initiateTracking('edit', 'Recommend An Exchange', 'Step 3 Review exchange and submit - Recommend exchange from', `Edit - ${scheduleTypeLabel} - Body`);
                            history.push({
                                pathname: `/investments/recommend-an-exchange/${id}/from`,
                                search: 'edit=true'
                            })
                        } catch (error) {
                          recordError(error);
                        }                       
                    }} />
                </FlexContainer>
                <Row>
                    <Col lg={24}>
                        <FromTable dataSource={from?.pools} exchangeType={from?.exchangeType} allocationType={from?.allocationType} />
                    </Col>
                </Row>
            </SectionSpacing>}
            <Divider className="m0" />
            {/** Do not show  Recommend Exchange To when exchange type is IntoTIFF */}
            {!(from?.exchangeType === ExchangeTypeConstants.intoTIFF) && <SectionSpacing>
                <FlexContainer>
                    <PageHeading>Recommend exchange to</PageHeading>
                    <CapsuleButton iconType="edit" text="Edit" id="btnEditExchangeTo" onClick={(e) => {
                        try {
                            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                            initiateTracking('edit', 'Recommend An Exchange', 'Step 3 Review exchange and submit - Recommend exchange to', `Edit - ${scheduleTypeLabel} - Body`);
                            history.push({
                                pathname: `/investments/recommend-an-exchange/${id}/to`,
                                search: 'edit=true'
                            })
                        } catch (error) {
                          recordError(error);
                        }
                    }} />
                </FlexContainer>
                <Row>
                    <Col lg={24}>
                        <ToTable dataSource={to?.pools} isReview={true} />
                    </Col>
                </Row>
            </SectionSpacing>}
            {from.scheduleType === ScheduleTypeConstants.recurring ?
                <SectionSpacing>
                    <FlexContainer>
                        <PageHeading>Recommend Exchange Schedule</PageHeading>
                    </FlexContainer>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12}>
                            <SpawnTable
                                frequency={from?.frequency}
                                numberOfExchanges={from?.numberOfExchanges}
                                startDate={from?.startDate} />
                        </Col>
                        <AddExchangeSection span={24}>
                            {/* A user will be able to add a maximum of 99 recurring payments under any frequency */}
                            {(from.numberOfExchanges >= ExchangesMaxLimitConstant) ? <>
                                <AddExchangeMessage>You have reached the maximum limit of recurring payments</AddExchangeMessage>
                                <CapsuleButton iconType="add" text="Add Payment" id="btnAddPayment" disabled={true} />
                            </>
                                : <CapsuleButton iconType="add" text="Add Payment" id="btnAddPayment" onClick={addPayment} />}
                        </AddExchangeSection>
                    </Row>
                    <Divider className='m0'/>            
                </SectionSpacing> : ''
            }
            <NavigationBtnContainer className='flex'>
                <ButtonWrapper>
                    <GeneralButton mobWidth="50%" type="functional" inverted={true} width="150px" text="Back" id="btnBack" onClick={handleBack}/>
                    <GeneralButton mobWidth="50%" type="functional" inverted={true} width="150px" text="Exit" id="btnExit" onClick={handleExit}/>
                </ButtonWrapper>
                <GeneralButton
                    width="150px" 
                    text="Submit" 
                    id="btnSubmit" 
                    onClick={handleSubmit}
                    disabled={ checkCsrBusiness('DONOR_PORTAL_SUBMIT_AN_EXCHANGE_FULL_ACCESS') || isSubmit}
                />
            </NavigationBtnContainer>
        </div>
    )
};

ExchangeReview.propTypes = {
    userId: PropTypes.string,
    handleExit: PropTypes.func,
    handleBack: PropTypes.func,
    getInitialData: PropTypes.func,
    edit: PropTypes.bool,
    id: PropTypes.string,
    isDirty: PropTypes.bool,
    isNew: PropTypes.bool,
}

export default withRouter(ExchangeReview);